module.exports = __webpack_public_path__ + "static/media/NO.812ccf4f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svgs/flags/NO.svg
// module id = 331
// module chunks = 0